import * as React from "react";

export const components = {
	solution_hero: React.lazy(() => import("./SolutionHero")),
	solution_benefits: React.lazy(() => import("./SolutionBenefits")),
	solution_features: React.lazy(() => import("./SolutionFeatures")),
	solution_case_study: React.lazy(() => import("./SolutionCaseStudy")),
	solution_social_proof: React.lazy(() => import("./SolutionLogos")),
	solution_video: React.lazy(() => import("./SolutionVideo")),
	client_logo: React.lazy(() => import("./SocialProof")),
	service: React.lazy(() => import("./Services")),
	herologos: React.lazy(() => import("./PressLogos")),
	reason: React.lazy(() => import("./Reasons")),
	whysections: React.lazy(() => import("./WhySlice")),
	core_value: React.lazy(() => import("./Values.js")),
	benefits_perks: React.lazy(() => import("./Benefits.js")),
	from_the_blog_posts: React.lazy(() => import("./FromBlog.js")),
	upcoming_event: React.lazy(() => import("./EventsList.js")),
	newsletter: React.lazy(() => import("./Newsletter.js")),
	// website_banner: React.lazy(() => import("./WebsiteBanner.js")),
};